import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from "next/router";
import styles from "../../styles/Master.module.scss";
import LgButton from "../../components/ButtonsCont/LgButton";
import SelectOptions from "../../components/TextInput/SelectOption";
import MasterServiceItem from "../../components/MasterServiceItem/MasterServiceItem";
import translate_word from "../../utils/translate";
import { useTranslation } from 'next-i18next';
import { Autocomplete, Dialog, DialogTitle, TextField } from '@mui/material';
import { get_services_by_address_saga } from '../../store/actions/service';
import { ClipLoader } from 'react-spinners';
import { useMemo } from 'react';
import { master_address_select } from '../../store/actions/master';
import { FormControl } from '@material-ui/core';
var canUseDOM = !!(
    (typeof window !== 'undefined' &&
        window.document && window.document.createElement)
);
function Service(props) {
    // const translate = useSelector(state => state.translate);
    const { t } = useTranslation();
    const { locale } = useRouter();
    const dispatch = useDispatch();
    const master_schedule = useSelector(state => state.master_schedule);
    const defaultValue = useMemo(() => {
        return props.master_data.data?.master_work_address?.filter((el) => el.work_address.id === +master_schedule?.selected_address)[0]?.work_address;
    }, [props.master_data.data]);
    // const [selectedService, setSelectedService] = useState(+props.service);
    // const handleClick = useCallback((id) => {
    //     setSelectedService(id);
    // }, [props.service]);
    // const { master_data, handleClick, category } = hooks(props);
    if (props.master && props.client && props.master === props.client) {
        return <div className={styles.master_information}>You can not access these services</div>;
    }
    return (
        // <div className="App"
        <div className={styles.master_information}>

            {/* {canUseDOM && !window.location.href.includes("register-master") ?
                <LgButton title={props.button_title} icon={<img className="icon-calendar" src="/calendar.svg" />} onClick={() => props.handleClick()} />
                : null} */}
            <div className={`mt-3 ${styles.autocomplete}`}>
                <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    className={styles.masters_filter}
                    getOptionLabel={(option) => option?.name}
                    defaultValue={defaultValue}
                    renderOption={(props2, option) => {
                        return (
                            <li {...props2}>
                                {option?.name}
                            </li>
                        );
                    }}
                    onChange={(event, values) => {
                        document.cookie = `address=${values?.id}; path=/`;
                        dispatch(master_address_select({ selected_address: values.id }));
                        dispatch(get_services_by_address_saga({ "master": props.master_data.data.id, "address": values.id }));
                    }}
                    // onChange={(event, values) => window.location = (`/masters/${values.slug}/${values.id}${props.city ? '?city=' + props.city : ''}`)}
                    options={props.master_data.data?.master_work_address?.map((item) => ({ ...item?.work_address }))}
                    renderInput={(params) => <TextField {...params} label={t("chooseWorkAddress")} defaultValue={defaultValue?.name} />}
                />
            </div>
            {props.master_data.service_loading && <div className='d-flex justify-content-center'>
                <ClipLoader color="#464646" size={15} />
            </div>}
            {!props.master_data.service_loading && props.category.map((item, index) => {
                return <div className="d-flex flex-column" key={index}>
                    <h3 className={styles.master_service_title}>{translate_word(item, locale)}</h3>
                    <div className={styles.master_service}>
                        {props.master_data.data.master_services
                            .filter(el => {
                                return el?.service_details?.sub_category?.id === item?.id;
                            })
                            .map((elem, ind) => {
                                const postFiles = props.master_data?.post_files?.[elem?.service_details?.id];
                                return <MasterServiceItem
                                    active={props.selectedService === elem?.service_details?.id}
                                    id={elem?.service_details?.id}
                                    service_id={elem?.id}
                                    master={props?.master_data?.data.id}
                                    key={ind}
                                    title={translate_word(elem?.service_details, locale)}
                                    subtitle={elem.subtitle}
                                    title_button={props.selectedService === elem?.service_details?.id ? t('chosenLabel') : t('appointmentLabel')}
                                    minutes={elem?.minutes}
                                    price={elem?.price}
                                    go_home={elem.go_home}
                                    go_home__price={elem?.go_home_price}
                                    post_files={postFiles}
                                    language={locale}
                                    token={props?.token}
                                    handleClick={() => {
                                        props.handleClick(elem?.id);

                                    }}
                                />;
                            })}
                    </div>
                </div>;
            })}
        </div>
    );
}
export default Service;
